import "./style.css";
import gsap from "gsap";

export default class HeroMenu {
  static selector = ".s-hero-menu";

  constructor(block) {
    this.block = block;
    this.$li = block.querySelectorAll("li");
    this.offset = block.querySelector("ul").getBoundingClientRect().x;
    this.$bar = block.querySelectorAll(".s-hero-menu--bar");
    this.$active = null;
  }

  setActive() {
    this.$li.forEach(($item, index) => {
      if ($item.classList.contains("__active")) {
        const { x, width } = $item.getBoundingClientRect();
        this.$active = $item;
        gsap.set(this.$bar, {
          width: width + 48,
          x: x - this.offset - 24,
        });
      }
    });
  }

  moveLine($el) {
    const { width, x } = $el.getBoundingClientRect();
    gsap.to(this.$bar, {
      duration: 0.65,
      ease: "power2.inOut",
      width: width + 32,
      x: x - this.offset - 16,
    });
  }

  addListeners() {
    this.$li.forEach(($item, index) => {
      $item.addEventListener("mouseenter", this.moveLine.bind(this, $item));
      $item.addEventListener(
        "mouseleave",
        this.moveLine.bind(this, this.$active)
      );
    });
  }

  onReady() {
    this.setActive();
    this.addListeners();
  }
}
